// extracted by mini-css-extract-plugin
export default {"modalHeader":"bIEIY2qXYtNgvzD7iYVl","close":"fU6x20_Y1r7_QHUcsGHF","icon":"tCXjZURu4yU3oThyEeac","placeHolderShimmer":"E246uipLL9B3Z0IUcMFQ"};